import React from 'react';
import { Card, CardContent } from '../ui/card';
import { processSteps } from '../../mock';

const HomeProcess = () => (
  <section className="py-16 bg-gray-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <div
          className="h-80 bg-cover bg-center rounded-lg mb-8"
          style={{
            backgroundImage:
              'url(https://images.squarespace-cdn.com/content/v1/5be9a984f8370a38e3b406f7/1736123812921-WR15AZAQ61VDNO2RQN8Z/pexels-cottonbro-4255489.jpg)',
          }}
        />
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">The Perfect Wine</h2>
        <p className="text-2xl text-red-900 font-semibold">For your special occasion!</p>
      </div>

      <h3 className="text-3xl font-bold text-center text-gray-900 mb-12">Our Process</h3>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
        {processSteps.map((step) => (
          <Card key={step.id} className="text-center hover:shadow-xl transition-shadow">
            <CardContent className="pt-8 pb-8">
              <div className="mb-6">
                <img src={step.icon} alt={step.title} className="w-24 h-24 mx-auto" />
              </div>
              <div className="mb-3">
                <span className="text-sm font-semibold text-[#FDB913] uppercase tracking-wide">
                  Step {step.id}
                </span>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">{step.title}</h4>
              <p className="text-gray-600 text-sm leading-relaxed">{step.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      <div className="mt-12 bg-white rounded-lg p-8 max-w-4xl mx-auto border border-gray-200">
        <p className="text-gray-700 leading-relaxed italic">
          The entire process is very simple. Your first visit, after selecting a wine, will only take 5 minutes.
          When you return for your bottling appointment, please set aside approximately 30 minutes for sterilization,
          bottle filling, and applying labels and shrink caps.
        </p>
      </div>
    </div>
  </section>
);

export default HomeProcess;
